import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// React logs most dev warnings via console.error, so DevTools shows them as errors.
// In dev only, re-route typical React warning strings to console.warn (yellow).
if (import.meta.env.DEV) {
  const originalError = console.error;
  console.error = (...args) => {
    const first = args[0];
    if (
      typeof first === 'string' &&
      (first.startsWith('Warning:') || first.includes('Warning: '))
    ) {
      console.warn(...args);
      return;
    }
    originalError.apply(console, args);
  };
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);